import { HTTPServiceClient } from '@/packages/http/service';
import * as t from './endpoints';
import {
  ReportResponse,
  GenerateReportRequest,
  DownloadReportRequest,
  GeneratedReportDetails,
  Report,
  GeneratExcelReportEvent
} from './types';
/**
 * --------------------------------------------------
 *	Cost Analysis HTTP Serice
 * --------------------------------------------------
 **/
export const ReportingService = {
  generateReport(
    generateReportRequest: GenerateReportRequest
  ): Promise<ReportResponse> {
    const body = { ...generateReportRequest };
    return HTTPServiceClient.post(
      t.GENERATE_REPORT(generateReportRequest.organizationId),
      body
    ).then(({ data }) => data);
  },

  generateExcelReport(
    generateReportRequest: GenerateReportRequest
  ): Promise<ReportResponse> {
    const body = { ...generateReportRequest };
    return HTTPServiceClient.post(
      t.GENERATE_REPORT(generateReportRequest.organizationId),
      body
    ).then(({ data }) => data);
  },

  async downloadReport(
    downloadReportRequest: DownloadReportRequest
  ): Promise<GeneratedReportDetails> {
    const { data } = await HTTPServiceClient.get(
      t.DOWNLOAD_REPORT(
        downloadReportRequest.organizationId,
        downloadReportRequest.jobId
      )
    );
    return data;
  },

  async getReports(organizationId: string): Promise<Report[]> {
    const { data } = await HTTPServiceClient.get(
      t.FETCH_REPORTS(organizationId)
    );
    return data.data;
  },

  async getComments(investmentId: string): Promise<any[]> {
    const { data } = await HTTPServiceClient.get(
      t.FETCH_COMMENTS(investmentId)
    );
    return data;
  }
};
